import React, {useEffect} from "react";
import {Col, Drawer, Form, Input, Row} from "antd";
import {useModel} from "../../../models";
import {MenuOutlined} from "@ant-design/icons";

const DetailForm = () => {
    const [form] = Form.useForm();
    const [{stockList, stockListSelectedRowKeys}] = useModel("stockStatistic");
    useEffect(() => {
        form.setFieldsValue(stockList.find(el => el.key === stockListSelectedRowKeys[0]))
    }, [form, stockList, stockListSelectedRowKeys])

    const onFinish = () => {

    }
    return (
        <Form
            form={form}
            name="material_detail"
            labelCol={{span: 8}}
            onFinish={onFinish}
        >

            <Row>
                <Col span={12}>
                    <Form.Item
                        name="materialCode"
                        label="商品编号"
                    >
                        <Input disabled={true} placeholder="商品编号"/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        name="materialName"
                        label="商品名称"
                    >
                        <Input disabled={true} placeholder="商品名称"/>
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Form.Item
                        name="replaceNum"
                        label="图号"
                    >
                        <Input disabled={true} placeholder="图号"/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        name="materialUnitName"
                        label="单位"
                    >
                        <Input disabled={true} placeholder="单位"/>
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Form.Item
                        name="categoryName"
                        label="商品类型"
                    >
                        <Input disabled={true} placeholder="商品类型"/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        name="engineTypeName"
                        label="发动机型号"
                    >
                        <Input disabled={true} placeholder="发动机型号"/>
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Form.Item
                        name="materialManufacturer"
                        label="产地"
                    >
                        <Input disabled={true} placeholder="产地"/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        name="materialBrandName"
                        label="品牌"
                    >
                        <Input disabled={true} placeholder="品牌"/>
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Form.Item
                        name="specification"
                        label="规格"
                    >
                        <Input disabled={true} placeholder="规格"/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        name="supplerName"
                        label="供应商"
                    >
                        <Input disabled={true} placeholder="供应商"/>
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Form.Item
                        name="purchasePrice"
                        label="进货价"
                    >
                        <Input disabled={true} placeholder="进货价"/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        name="procurementCost"
                        label="平均价"
                    >
                        <Input disabled={true} placeholder="平均价"/>
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Form.Item
                        name="inventoryTotal"
                        label="金额"
                    >
                        <Input disabled={true} placeholder="金额"/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        name="holdNum"
                        label="占用库存"
                    >
                        <Input disabled={true} placeholder="占用库存"/>
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Form.Item
                        name="availableNum"
                        label="可用库存"
                    >
                        <Input disabled={true} placeholder="可用库存"/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        name="inventoryNum"
                        label="库存数量"
                    >
                        <Input disabled={true} placeholder="库存数量"/>
                    </Form.Item>
                </Col>
            </Row>

            <Row>
                <Col span={12}>
                    <Form.Item
                        name="salesPrice"
                        label="销售价"
                    >
                        <Input disabled={true} placeholder="销售价"/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        name="inventoryCap"
                        label="库存上线"
                    >
                        <Input disabled={true} placeholder="库存上线"/>
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Form.Item
                        name="inventoryFloor"
                        label="库存下限"
                    >
                        <Input disabled={true} placeholder="库存下限"/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        name="orgName"
                        label="机构"
                    >
                        <Input disabled={true} placeholder="机构"/>
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Form.Item
                        name="warehouseName"
                        label="仓库"
                    >
                        <Input disabled={true} placeholder="仓库"/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        name="shelfCode"
                        label="货位"
                    >
                        <Input disabled={true} placeholder="货位"/>
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    )
}

const Title = () => {
    return (
        <h3>
            <MenuOutlined/>
            <span className="margin-left-8">库存详情</span>
            <span className="margin-left-16">物料编码-CGHD12065656</span>
        </h3>
    )
}
export default function () {
    const [{detailVisible}, {setDetailVisible}] = useModel("stockStatistic")
    const onClose = () => {
        setDetailVisible(false);
    }
    return (
        <Drawer
            title={<Title/>}
            placement="right"
            closable={true}
            onClose={onClose}
            visible={detailVisible}
            width={750}
        >
            <DetailForm/>
        </Drawer>
    )
}